module.exports = __webpack_public_path__ + "img/chapter__7_image_1.6f1aa18f.jpg";